<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="option-wrap">
      <Select v-model="search.audit_status" style="width: 150px;margin-right:10px;" @on-change="loadData">
        <Option :value="9">全部</Option>
        <Option :value="1">已通过</Option>
        <Option :value="2">待处理</Option>
      </Select>
      <all-user ref="allUser" :type="'all'" @usernameChange="usernameChange"></all-user>
    </div>
    <div class="select-box input_left_two">
      <Input v-model="version" style="width:150px;" placeholder="请输入版本号" :rows="4" />
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="select-box-type-pl">
      <Select v-model="plType" style="width:150px" @on-change="changePlType" placeholder="请选择批量操作">
        <Option value="2" key="2">批量通过</Option>
        <Option value="3" key="3">批量拒绝</Option>
      </Select>
    </div>
    <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal :mask-closable="false"
           v-model="checkdata"
           title="审核驳回"
           :loading="loading"
           @on-cancel="cancelReason"
           @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="驳回理由" prop="reason">
          <Input type="textarea" placeholder="请输入驳回理由，限制50字" v-model="formValidate.aduit_con" maxlength="50" />
        </FormItem>
      </Form>
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPush"
      title="批量通过"
      @on-ok="editDataPL(false)"
      @on-cancel="cancelModal"
      >
      是否将{{this.tableSelectRow.length}}个应用通过审核
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="plPublish"
      title="批量拒绝"
      @on-ok="editDataPL(true)"
      @on-cancel="cancelModal"
      >
      是否将{{this.tableSelectRow.length}}个应用拒绝审核
      <Form ref="formValidatePl" :model="formValidatePl" :label-width="120">
        <FormItem label="驳回理由" prop="reason">
          <Input type="textarea" placeholder="请输入驳回理由，限制50字" v-model="formValidatePl.aduit_con" maxlength="50" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import allUser from '@/components/global/allUser'
import https from '../../https'
import utils from '../../utils'
export default {
  name: 'checkVersion',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      selectItems: [],
      sdkVersion: [],
      check: [
        { name: '待审核', val: 1 },
        { name: '审核通过', val: 2 },
        { name: '审核驳回', val: 3 }
      ],
      tableSelectRow: [],
      plType: 0,
      plPush: false,
      plPublish: false,
      version: '',
      formValidatePl: {
        ver: ''
      },
      search: {
        audit_status: 9
      },
      formValidate: {
        audit_status: '',
        aduit_con: ''
      },
      ruleValidate: {
        aduit_con: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 50, message: '最多输入50个字', trigger: 'blur' }
        ]
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: '小程序应用名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: '审核状态',
          key: 'audit_status',
          width: 130,
          align: 'center',
          render: (h, params) => {
            let checked = ''
            this.check.forEach(n => {
              if (n.val === params.row.audit_status) checked = n.name
            })
            let html = [
              h('span', checked)
            ]
            if (params.row.audit_status === 3 && params.row.aduit_con) {
              html.push(h('Tooltip', {
                props: {
                  placement: 'bottom',
                  content: params.row.aduit_con
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'ios-help-circle-outline'
                  },
                  style: {
                    color: '#f00'
                  }
                })
              ]))
            }
            return h('div', html)
          }
        },
        {
          title: '版本号',
          key: 'package_ver',
          width: 100,
          align: 'center'
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 300
        },
        {
          title: 'SDK版本',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let name = ''
            if (!params.row.sdk_ver_s && !params.row.sdk_ver_e) {
              name += '不限'
            } else {
              if (params.row.sdk_ver_s) {
                name += params.row.sdk_ver_s
              } else {
                name += '不限'
              }
              if (params.row.sdk_ver_e) {
                name += (' - ' + params.row.sdk_ver_e)
              } else {
                name += ' - 不限'
              }
            }
            return h('span', name)
          }
        },
        {
          title: '操作人',
          key: 'update_by',
          align: 'center',
          width: 200
        },
        {
          title: '创建时间',
          key: 'created_at',
          align: 'center',
          width: 200,
          render: (h, params) => {
            return h('span', params.row.created_at)
          }
        },
        {
          title: '审核时间',
          key: 'updated_at',
          align: 'center',
          width: 200,
          render: (h, params) => {
            return h('span', params.row.updated_at)
          }
        },
        {
          title: '操作',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: params.row.audit_status === 2 || params.row.audit_status === 3
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editId = params.row.id
                    this.formValidate.audit_status = 2
                    this.editData('formValidate')
                  }
                }
              }, '通过'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.audit_status === 2 || params.row.audit_status === 3
                },
                on: {
                  click: () => {
                    this.checkdata = true
                    this.formValidate.audit_status = 3
                    this.editId = params.row.id
                  }
                }
              }, '拒绝')
            ])
          }
        }
      ],
      tvpList: [],
      searchName: '',
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb,
    allUser
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
  },
  methods: {
    formatDay: utils.formatDay,
    tableOnSelect (row) {
      console.log(row)
      // this.tableSelectRow.push(row)
      this.tableSelectRow = this.unique(this.tableSelectRow.concat(row))
    },
    // 加载tabs列表
    loadData () {
      let params = {
        page_size: this.pageSize,
        page: this.current,
        status: this.search.audit_status,
        version: this.version,
        uid: this.searchName
      }
      https.request({
        method: 'get',
        // url: '/v1/check/appver',
        url: '/v2/es/audit/vers',
        params: params
      }).then(res => {
        this.tableSelectRow = []
        this.tableLoading = false
        // this.dataList = res.data.items
        this.getUserNameFun(res.data.items)
        this.total = res.data.total
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.uid)
      })
      let str = arr.join(',')
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (Number(item.value) === sItem.uid) {
              sItem['userName'] = item.text
            }
          })
        })
        this.dataList = list
        this.updateChecked()
      })
    },
    unique (arr) {
      const res = new Map()
      return arr.filter((r) => !res.has(r.id) && res.set(r.id, 1))
    },
    updateChecked () {
      console.log(this.dataList.length)
      for (var i = 0; i < this.dataList.length; i++) {
        this.dataList[i]._checked = false
        console.log(this.dataList[i].audit_status)
        if (this.dataList[i].audit_status !== 1) {
          this.dataList[i]._disabled = true
        }
        for (var j = 0; j < this.tableSelectRow.length; j++) {
          if (this.tableSelectRow[j].id === this.dataList[i].id) {
            this.dataList[i]._checked = true
          }
        }
      }
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.version = ''
      this.search.audit_status = '9'
      this.tableSelectRow = []
      this.searchName = ''
      this.$refs.allUser.clear()
      this.loadData()
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
      setTimeout(() => {
        this.updateChecked()
      }, 1000)
    },
    usernameChange (val) {
      this.searchName = val
      this.loadData()
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    changePlType () {
      // console.log(this.tableSelectRow)
      if (this.plType === '2') {
        // audit_status
        console.log('批量通过')
        this.plPush = true
      } else if (this.plType === '3') {
        console.log('批量继绝')
        this.plPublish = true
      }
    },
    cancelModal () {
      this.plType = 0
    },
    editDataPL (type) {
      if (this.tableSelectRow.length === 0) {
        this.plType = 0
        this.$Message.error('请先选择应用')
        return
      }
      let arr = []
      this.tableSelectRow.map(item => {
        arr.push(item.id)
      })
      let params = new FormData()
      if (type) {
        params.append('aduit_con', this.formValidatePl.aduit_con)
      }
      params.append('status', this.plType)
      params.append('ids', arr)
      https.request({
        method: 'put',
        url: '/v2/es/audit/appver/batch',
        data: params
      }).then(res => {
        this.plType = 0
        this.loadData()
        this.tableSelectRow = []
        this.formValidatePl.aduit_con = ''
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    cancelReason () {
      // this.$refs['formValidate'].resetFields()
      this.formValidate.aduit_con = ''
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            let params = {
              status: this.formValidate.audit_status,
              id: this.editId
            }
            if (this.formValidate.audit_status === 3) {
              params.aduit_con = this.formValidate.aduit_con
            }
            https.request({
              method: 'put',
              url: '/v2/es/audit/appver',
              data: params
            }).then(res => {
              console.log(res)
              if (res.data && res.data.code === 400) {
                this.$Message.error(res.data.message)
                this.checkdata = false
                this.loadData()
                return
              }
              this.$Message.success('提交成功')
              this.$refs['formValidate'].resetFields()
              this.formValidate = {
                audit_status: '',
                aduit_con: ''
              }
              this.checkdata = false
              this.loadData()
            }).catch(error => {
              this.$Message.error(error)
            })
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 134px;
    right: 260px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 137px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .input_left_two{
    left:611px;
    // left:580px;
  }
  .input_left_three{
    left:775px;
    // left:755px;
  }
  .option-wrap{
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/check/checkVersion.vue